export default __webpack_public_path__ + "img/label.puroak.06.asset.b1b1f8cb.png";